import { useMutation } from "@tanstack/react-query";
import { Button, message } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { MdDeleteForever } from "react-icons/md";
import { useParams } from "react-router-dom";
import { DeleteTimeOffAdmin } from "../../../network/admin";
import queryClient from "../../../services/react-query/queryClient";
import { teamMember } from "../../../types/calendar";
import AddTimeOff from "../../teamMember/workingHours/AddTimeOff";

type Props = { data: teamMember; vacations: any };

const TeamMemberVacation = ({ data, vacations }: Props) => {
  const locationId = useParams()?.salonName;
  const [openModal, setOpenModal] = useState(false);
  const [selectedVacationToEdit, setSelectedVacationToEdit] = useState<
    number | null
  >(null);
  const { mutate: DeleteTimeOff, isLoading: isLoadingDelete } = useMutation(
    DeleteTimeOffAdmin,
    {
      onSuccess: (res: any) => {
        if (res?.code === "ERR_BAD_REQUEST" || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          message.success("vacation deleted");
          console.log(res?.code);
          console.log(res);
          queryClient.invalidateQueries(["vacation"]);
        }
      },
    }
  );
  console.log(data, vacations);

  return (
    <>
      <div className="w-full rounded-lg flex items-center gap-2 text-white">
        <div className="flex gap-4 rounded-lg text-sm justify-between bg-[#4f5062] w-full px-2 py-2 h-full">
          <div className="flex items-center flex-col w-full gap-4">
            {vacations?.map((e: any) => (
              <div className="bg-[#9999A7] px-3 py-[10px] h-full rounded-lg w-full flex items-center justify-between">
                <span className="text-sm text-[#EEF0FF] font-normal">
                  <span>{dayjs(e?.date).format("YYYY-MM-DD")}</span>
                </span>
                <div
                  className="font-medium flex items-center gap-4 text-xs cursor-pointer"
                  // onClick={() => {
                  //   setSelectedVacationToEdit(null); //! static vacation till fetch vacations data
                  //   setOpenModal(true);
                  // }}
                >
                  <span className="text-[#4F5062] text-xs">Vacation</span>
                  <MdDeleteForever
                    onClick={() =>
                      DeleteTimeOff({
                        salonId: data?.locations[0]?.salon_id,
                        teamMemberId: e?.team_member?.id,
                        id: e?.id,
                      })
                    }
                    className="text-white flex items-center text-lg justify-center text-center"
                  />
                </div>
              </div>
            ))}
          </div>
          <Button
            type="default"
            className="text-color-primary flex items-center text-sm font-medium bg-white rounded-lg !py-2 px-4 whitespace-nowrap"
            onClick={() => setOpenModal(true)}
          >
            <span className="mx-1 flex items-center text-xs">+</span>
            New Vacation
          </Button>
        </div>
      </div>
      <AddTimeOff
        onClose={() => setOpenModal(false)}
        team_member_id={data?.id}
        selectedDate={new Date()}
        visible={openModal}
        config={{
          isAdmin: true,
          isEdit: !!selectedVacationToEdit,
          salonId: data?.locations[0]?.salon_id || undefined,
        }}
      />
    </>
  );
};

export default TeamMemberVacation;
